module.exports = __webpack_public_path__ + "logo-prodfor.e194ce78024a65fcdaab.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/img/logo-prodfor.png
// module id = ../../../../../src/assets/img/logo-prodfor.png
// module chunks = styles